/* Contains all color schemes used by the application */
export const colorCodes = {
    intelliGreen: '#01C591',
    intelliDarkGreen: '#27917F',
    intelliDarkerGreen: '#0C454C',
    intelliLightGreen: '#66E2C0',
    intelliBlue: '#012638',
    intelliLightBlue: '#29769B'
}